import { render, staticRenderFns } from "./GroupOpportunitiesForm.vue?vue&type=template&id=3d175a7a"
import script from "./GroupOpportunitiesForm.vue?vue&type=script&lang=js"
export * from "./GroupOpportunitiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports